import type { Release } from '../releases.ts';

export default {
  version: '0.90.0',
  date: '2026-10-15',
  title: 'Refactor: shared helpers, split modules, unified test helpers',
  summary: [
    'A maintenance release: PRISM works as in 0.31.0, its code reorganised into shared helpers and smaller modules',
    'Some settings are checked at startup, and an invalid number stops the API',
    'No migrations: going back to 0.31.0 is a plain redeploy',
    'Fixed: archive tiering keeps running after a database connection error',
  ],
  features: [
    'A maintenance release: PRISM works as it did in 0.31.0. Under the hood the code was reorganised so that it is easier to keep correct: repeated code became shared helpers (HTTP errors and responses, file handling, signing media links, service authentication, settings), large files were split into smaller modules (agent, automation, storage and watch-folder routes in the API; the Library, the asset tabs, the player and the admin pages in the app; shared definitions in contracts and media), and the tests use one set of helpers',
    'Settings are checked at startup: PRISM_TIERING_INTERVAL_SECONDS, PRISM_LOGIN_WINDOW_MINUTES, PRISM_LOGIN_MAX_FAILURES, PRISM_LOGIN_MAX_FAILURES_PER_ADDRESS and PRISM_LIVE_HOST are now validated when the API starts. An invalid number stops the API; an empty value means the default',
    'No migrations in this release: going back to 0.31.0 is a plain redeploy',
  ],
  fixes: [
    'The archive tiering scheduler keeps running after a database connection error',
  ],
} satisfies Release;
